// extracted by mini-css-extract-plugin
export default {"sticky":"FieldTable_sticky__P7ild"};